import { Box, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import RootComponents from "../../../components/common/RootComponents";
import styles from "../InternalTracker.module.css";
import { customTextColor, formatDate } from "../../../utils/const";
import { useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import SideDrawer from "./SideDrawer";
import { IoIosSearch } from "react-icons/io";
import { PiMailboxLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { PiLinkedinLogoLight } from "react-icons/pi";
import { PiChairLight } from "react-icons/pi";
import { PiAddressBookLight } from "react-icons/pi";
import { PiIdentificationCardLight } from "react-icons/pi";
//   import SideIcon from "./SideIcon";
import { BsThreeDotsVertical } from "react-icons/bs";
import Search from "../../../assets/images/search (2).png";
import { BsFileEarmarkText } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import MoreFilterView from "../../../components/containers/MoreFilterView";
import { useSelector } from "react-redux";
import Resume from "../../../assets/images/Resume - Profile.png";
import { IoDesktopOutline } from "react-icons/io5";
import { PiUserLight } from "react-icons/pi";

// Function to split skills into columns for layout
const splitIntoColumns = (skills, columns) => {
  const result = Array?.from({ length: columns }, () => []);
  skills?.forEach((skill, index) => {
    result[index % columns]?.push(skill);
  });
  return result;
};

const MoreViewDetails = () => {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);

  const [oppen, setOppen] = useState(false);
  const [side, setSide] = useState(false);

  const handleCloseSide = () => setSide(false);
  const handleSide = () => setSide(true);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const location = useLocation();
  const { res } = location.state || {};
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location) || [];
  const skillData = useSelector((state) => state.skill.data);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [isProfileVisible, setIsProfileVisible] = useState(false);

  const handleThreeDotsClick = () => {
    setIsProfileVisible(!isProfileVisible);
  };
  const [typeResult, setTypeResult] = useState("public");
  const navigate = useNavigate();

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const matchingSkills = skillData?.locations?.filter((skill) =>
    res?.skills?.includes(skill.id)
  );
  const columns = splitIntoColumns(matchingSkills, 4);

  const matchingSkills2 = skillData?.locations?.filter((skill) =>
    res?.secondary_skills?.includes(skill.id)
  );
  const columns2 = splitIntoColumns(matchingSkills2, 4);

  const handleToggleDialog = () => {
    setDialogOpen((prev) => !prev);
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert("Copied to clipboard!");
    });
  };

  return (
    // <RootComponents>
    <>
      <Box className={styles.search_candidate_stucture}>
        {/* <Box className={styles.job_serach_result_heading}>
          <Typography sx={{ color: customTextColor }}>
            Candidate Details
          </Typography>
          <span onClick={handleShow}>
            <Typography sx={{ color: customTextColor }}>
              Kevin Macklin - Submission History
            </Typography>
            <IoIosArrowBack
              className={styles.arrow_icon}
              style={{ color: "rgb(147 145 145)", fontSize: "18px" }}
            />
          </span>
        </Box> */}
        {/*   
          <SideIcon handleClose={handleCloseSide} side={side} /> */}

        <Box className={styles.job_serach_result_heading}>
          <Typography>
            Activities Since: <b>{formatDate(res?.created_at)}</b>
          </Typography>
          <span>
            <Typography sx={{ fontSize: "18px !important", color: "#3856a6" }}>
              {res?.filled_percentage}%
            </Typography>
            <span
              style={{ marginLeft: "10px" }}
              className={styles.view_profile_link}
              onClick={() => {
                navigate("/internal-tracker-add");
                localStorage.setItem(
                  "internalTrackerCandidateAddOrUpdate",
                  JSON.stringify({
                    row: res,
                    types: "view_update",
                  })
                );
              }}
            >
              Profile Completed
            </span>
            <BsThreeDotsVertical
              onClick={handleShow}
              style={{ fontSize: "20px", marginLeft: "10px" }}
            />
          </span>
        </Box>

        {/* {isProfileVisible && (
          <Box className={styles.profile_and_submit}>
            <Box>
              <Typography>
                <b>Profile Uploaded By</b>
              </Typography>
              <Typography sx={{ marginTop: "10px !important" }}>
                Name: <b>Harish *****</b>
              </Typography>
              <Typography>
                Designation: <b>Sr. Recruiter</b>
              </Typography>
              <Typography>
                Categories:
                <b>Mutual 21</b>
              </Typography>
            </Box>
            <Box
              className={styles.phase2}
              sx={{ marginTop: "20px !important" }}
            >
              <BsFileEarmarkText
                style={{
                  cursor: "pointer",
                  fontSize: "50px",
                  color: "#2e6ca3",
                  marginBottom: "5px",
                }}
              />
              <Typography>
                <b>Get Resume</b>
              </Typography>
            </Box>
          </Box>
        )} */}

        <Box className={styles.profile_and_submit}>
          <Box>
            <Typography>
              <b>Profile Credited by</b>
            </Typography>
            <Typography sx={{ marginTop: "10px !important" }}>
              {res?.profile_created_by}
            </Typography>
            {/* <Typography>Active Mutual 17</Typography> */}
          </Box>
          <Box className={styles.phase2}>
            <img
              src={Resume}
              alt="attachment"
              style={{
                width: "50px",
                backgroundColor: "#e1eaf0",
                padding: "6px",
                borderRadius: "3px",
              }}
            />
            <Typography sx={{ marginTop: "5px" }}>Get Resume</Typography>
          </Box>
        </Box>
        <Grid container className={styles.profile_phase}>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ border: "none !important" }}
          >
            <Typography sx={{ marginLeft: "0 !important" }}>
              <PiUserLight
                style={{
                  fontSize: "33px",
                  backgroundColor: "#bed7ed",
                  padding: "4px",
                  borderRadius: "3px",
                  color: "#4c68b0",
                }}
              />

              <b style={{ marginLeft: "10px" }}> {res?.full_name} </b>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <Typography>
              {" "}
              <PiChairLight
                style={{
                  fontSize: "33px",
                  backgroundColor: "#bed7ed",
                  padding: "4px",
                  borderRadius: "3px",
                  color: "#4c68b0",
                }}
              />
              <b style={{ marginLeft: "10px" }}>{res?.current_job_title}</b>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <Typography>
              <PiAddressBookLight
                style={{
                  fontSize: "33px",
                  backgroundColor: "#bed7ed",
                  padding: "4px",
                  borderRadius: "3px",
                  color: "#4c68b0",
                }}
              />

              <b style={{ marginLeft: "10px" }}>
                {" "}
                {res?.total_experience} Years’ Experience
              </b>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ color: customTextColor }}
          >
            <Typography>
              <PiIdentificationCardLight
                style={{
                  fontSize: "33px",
                  backgroundColor: "#bed7ed",
                  padding: "4px",
                  borderRadius: "3px",
                  color: "#4c68b0",
                }}
              />

              <b style={{ marginLeft: "10px" }}>
                {getWorkAuthorization(res?.work_authorization)}{" "}
              </b>
            </Typography>
          </Grid>
        </Grid>
        <Box className={styles.matches_and_submit}>
          {/* <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ color: customTextColor }}
            >
              <Box>
                <ul
                  style={{
                    listStyleType: "square",
                    padding: "5px 20px",
                    marginBottom: "10px",
                  }}
                >
                  <Box>
                    <li>
                      <Typography>
                        Current Location: <b>Ratmithali, Kolkata, KK</b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        Tax Term: <b>Full Time </b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        Work Preference: <b>Remote</b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        Domain & Industry: <b>Healthcare</b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography sx={{ marginBottom: "0 !important" }}>
                        Qualifications: <b>B Tech</b>
                      </Typography>
                    </li>
                  </Box>
                </ul>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{
                color: customTextColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <ul
                  style={{
                    listStyleType: "square",
                    padding: "5px 20px",
                    marginBottom: "10px",
                  }}
                >
                  <Box>
                    <li>
                      <Typography>
                        Prefer Location: <b>Chennai, Delhi</b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        Rate: <b>$100 Hourly </b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        Current Organization: <b>ABC Technologies Pvt Ltd </b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        University: <b>Boston Texas in 2015</b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography sx={{ marginBottom: "0 !important" }}>
                        Linked in Profile: <b>pratick_java.linkedin.com</b>
                      </Typography>
                    </li>
                  </Box>
                </ul>
              </Box>

              <Box>
                <Typography>
                  <div
                    style={{
                      backgroundColor: "#e1eaf0",
                      padding: "7px",
                      borderRadius: "3px",
                    }}
                  >
                    <CiMobile3 style={{ fontSize: "22px" }} />
                  </div>
                </Typography>
                <Typography>
                  <div
                    style={{
                      backgroundColor: "#e1eaf0",
                      padding: "7px",
                      borderRadius: "3px",
                    }}
                  >
                    <PiMailboxLight style={{ fontSize: "22px" }} />
                  </div>
                </Typography>

                <Typography>
                  <div
                    style={{
                      backgroundColor: "#e1eaf0",
                      padding: "7px",
                      borderRadius: "3px",
                    }}
                  >
                    <PiLinkedinLogoLight style={{ fontSize: "22px" }} />
                  </div>
                </Typography>
              </Box>
            </Grid>
          </Grid> */}
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ color: customTextColor }}
            >
              <Box>
                <ul
                  style={{
                    listStyleType: "square",
                    padding: "5px 20px",
                    marginBottom: "10px",
                  }}
                >
                  <Box>
                    <li>
                      <Typography>
                        Current Location:{" "}
                        <b>{getLocationById(res?.current_location)}</b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        Tax Term: <b>{res?.prefer_tax_team}</b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        Work Preference: <b>{res?.work_preference}</b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        Domain & Industry: <b>{res?.domain_name}</b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography sx={{ marginBottom: "0 !important" }}>
                        Qualifications: <b> {res?.highest_qualification}</b>
                      </Typography>
                    </li>
                  </Box>
                </ul>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{
                color: customTextColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <ul
                  style={{
                    listStyleType: "square",
                    padding: "5px 20px",
                    marginBottom: "10px",
                  }}
                >
                  <Box>
                    <li>
                      <Typography>
                        Prefer Location:{" "}
                        <b>{getPreferLocationNames(res?.prefer_location)}</b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        {res?.prefer_tax_team === "full_Time"
                          ? "Salary"
                          : "Rate"}
                        :{" "}
                        <b>
                          ${res?.rate} {""}
                          {res?.prefer_tax_team === "full_Time"
                            ? "Yearly"
                            : "Hourly"}{" "}
                        </b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        Current Organization: <b>{res?.current_company} </b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        University: <b>{res?.university}</b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography sx={{ marginBottom: "0 !important" }}>
                        Linked in Profile: <b>{res?.linkedin_profile_url}</b>
                      </Typography>
                    </li>
                  </Box>
                </ul>
              </Box>
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Box className="icon-container">
                  <Typography onClick={handleToggleDialog}>
                    <div
                      style={{
                        backgroundColor: "#e1eaf0",
                        padding: "7px",
                        borderRadius: "3px",
                      }}
                    >
                      <CiMobile3 style={{ fontSize: "22px" }} />
                    </div>
                  </Typography>
                  <Typography onClick={handleToggleDialog}>
                    <div
                      style={{
                        backgroundColor: "#e1eaf0",
                        padding: "7px",
                        borderRadius: "3px",
                      }}
                    >
                      <PiMailboxLight style={{ fontSize: "22px" }} />
                    </div>
                  </Typography>

                  <Typography onClick={handleToggleDialog}>
                    <div
                      style={{
                        backgroundColor: "#e1eaf0",
                        padding: "7px",
                        borderRadius: "3px",
                      }}
                    >
                      <PiLinkedinLogoLight style={{ fontSize: "22px" }} />
                    </div>
                  </Typography>
                </Box>
              </div>
              {dialogOpen && (
                <div className="dialog dialog-open">
                  <div className="dialog-content">
                    {/* <p>Profile Views: {userInfo.profileViews}</p> */}
                    <p>Phone Number: {res?.mobile_no}</p>
                    <p
                      className="copy-text"
                      onClick={() => handleCopy(res?.email)}
                    >
                      Copy Email
                    </p>
                    <p
                      className="copy-text"
                      onClick={() => handleCopy(res?.linkedin_profile_url)}
                    >
                      Copy LinkedIn
                    </p>
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </Box>
        <Grid container sx={{ backgroundColor: "#fff", margin: "14px 0" }}>
          <Grid item xs={12}>
            <Box className={styles.list_details}>
              <Typography sx={{ marginBottom: "20px !important" }}>
                <b> Primary skills</b>
              </Typography>
              <Grid container sx={{ fontWeight: "600" }}>
                {columns.map((column, colIndex) => (
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={3}
                    lg={3}
                    key={colIndex}
                    sx={{
                      borderLeft: colIndex !== 0 ? "2px solid white" : "none",
                      paddingLeft: colIndex !== 0 ? "20px" : "0",
                    }}
                  >
                    <Box sx={{ color: customTextColor }}>
                      {column.map((skill) => (
                        <Typography
                          key={skill.id}
                          sx={{ marginBottom: "0 !important" }}
                        >
                          {skill.name}
                        </Typography>
                      ))}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>

        <Grid container sx={{ backgroundColor: "#fff", margin: "14px 0" }}>
          <Grid item xs={12}>
            <Box className={styles.list_details}>
              <Typography sx={{ marginBottom: "20px !important" }}>
                <b> Secondary skills</b>
              </Typography>
              <Grid container sx={{ fontWeight: "600" }}>
                {columns2.map((column, colIndex) => (
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={3}
                    lg={3}
                    key={colIndex}
                    sx={{
                      borderLeft: colIndex !== 0 ? "2px solid white" : "none",
                      paddingLeft: colIndex !== 0 ? "20px" : "0",
                    }}
                  >
                    <Box sx={{ color: customTextColor }}>
                      {column.map((skill) => (
                        <Typography
                          key={skill.id}
                          sx={{ marginBottom: "0 !important" }}
                        >
                          {skill.name}
                        </Typography>
                      ))}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>

        {res?.prefer_tax_team === "contract" ||
        res?.prefer_tax_team === "contract_to_hire" ? (
          <Grid
            container
            className={styles.requirement_details_view}
            sx={{ backgroundColor: "#dfebf7", margin: "14px 0" }}
          >
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <span>
                <Box>
                  <PiUserLight
                    style={{
                      fontSize: "32px",
                      backgroundColor: "#bed7ed",
                      padding: "5px",
                      borderRadius: "3px",
                      color: "#4c68b0",
                    }}
                  />
                  <Typography>
                    Employer Name: <b>{res?.employer_manager_name}</b>
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: "0 !important" }}>
                  <PiMailboxLight
                    style={{
                      fontSize: "32px",
                      backgroundColor: "#bed7ed",
                      padding: "5px",
                      borderRadius: "3px",
                      color: "#4c68b0",
                    }}
                  />
                  <Typography>
                    Work Email ID : <b>{res?.employer_email}</b>
                  </Typography>
                </Box>
              </span>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6}>
              <span>
                <Box>
                  <PiUserLight
                    style={{
                      fontSize: "32px",
                      backgroundColor: "#bed7ed",
                      padding: "5px",
                      borderRadius: "3px",
                      color: "#4c68b0",
                    }}
                  />
                  <Typography>
                    Company Name: <b>{res?.employer_company_name}</b>
                  </Typography>
                </Box>

                <Box sx={{ marginBottom: "0 !important" }}>
                  <CiMobile3
                    style={{
                      fontSize: "32px",
                      backgroundColor: "#bed7ed",
                      padding: "5px",
                      borderRadius: "3px",
                      color: "#4c68b0",
                    }}
                  />
                  <Typography>
                    Work Phone No: <b>{res?.employer_mobile_no}</b>
                  </Typography>
                </Box>
              </span>
            </Grid>
          </Grid>
        ) : (
          ""
        )}

        {/*         
          <Box className={styles.profile_status_details_btns}>
            <img src={profile_image} alt="" />
  
            <Box className={styles.add_back_btns}>
              <button
                style={{
                  backgroundColor: "#2e75b6",
                  marginRight: "350px",
                }}
              >
                View Contact
              </button>
  
              <Box>
                <button
                  onClick={handleClickOpen}
                  style={{
                    backgroundColor: "#00b050",
                    marginLeft: "150px",
                  }}
                >
                  Send Requirement
                </button>
              </Box>
           
            </Box>
          </Box> */}
        <Box className={styles.internal_update_btns}>
          <Box className={styles.add_back_btns}>
            <button
              onClick={() => navigate(-1)}
              style={{
                border: "1.5px solid #4285f4",
                marginRight: "10px",
                padding: "4.5px 10px ",
              }}
            >
              <IoIosArrowRoundBack
                style={{ fontSize: "25px", color: "#4285f4" }}
              />
            </button>
          </Box>
          <Box>
            <button
              style={{ backgroundColor: "#3856a6 ", padding: "7.5px 15px " }}
              onClick={() => navigate("/internal-tracker-add")}
            >
              Next Profile
            </button>
          </Box>
        </Box>
        <SideDrawer
          handleShow={handleShow}
          handleClose={handleCloseShow}
          show={show}
          res={res}
        />
      </Box>
      {/* 
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        sx={{ padding: "0 14px 0 14px" }}
      >
        <Box className={styles.choose_resume}>
          <Typography
            onClick={() => setTypeResult("public")}
            sx={
              typeResult === "public"
                ? { color: "#1991e0" }
                : { color: customTextColor }
            }
          >
            Private Matching 17
          </Typography>
          <Typography
            sx={
              typeResult === "internal"
                ? { color: "#95cb6d" }
                : { color: customTextColor }
            }
          >
            Internal Matching 170
          </Typography>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        sx={{ padding: "14px 14px 0 14px" }}
      >
        {typeResult === "public" ? (
          <>
            <MoreFilterView
              name="Himanshu Sekhar"
              job=" Lead Java Developer"
              location="Noida Delhi, DL"
              work="Green Card"
              skills="Hibernate 2 Years | Spring Boot 4 Years | ASW Cloud 2 Years | GO 2 Years"
              btn1="View Profile"
              //   btn2="Send E-Mail"
              matches="Mathes 97%"
            />
            <MoreFilterView
              name=" Pratik Reddy"
              job=" Lead Java Developer"
              location="Kolkata, KK"
              work="Rs 25k PM"
              skills=" Hibernate 2 Years | Spring Boot 4 Years | ASW Cloud 2 Years | GO 2 Years"
              btn1="Viewed"
              //   btn2="Send E-Mail"
              matches="Mathes 95%"
            />
            <MoreFilterView
              name=" Rasmi Ranjan Reddy"
              job=" Lead Java Developer"
              location="Kolkata, KK "
              work="Rs 22k PM"
              skills="Hibernate 2 Years | Spring Boot 4 Years | ASW Cloud 2 Years | GO 2 Years"
              btn1="Viewed"
              //   btn2="Send E-Mail"
              matches="Matches 90%"
            />
          </>
        ) : (
          <></>
        )}
      </Grid>

      <Box className={styles.select_search_result_btns}>
        <button style={{ alignSelf: "flex-end " }}>Select All</button>
      </Box> */}

      {/* <Box className={styles.select_search_result_btns}>
          <button style={{ alignSelf: "flex-end " }}>Select All</button>
        </Box> */}
    </>
    // </RootComponents>
  );
};

export default MoreViewDetails;
